/* eslint-disable array-callback-return */
import {
  Component,
  ElementRef,
  OnDestroy,
  OnInit,
  Renderer2,
  ViewChild
} from '@angular/core';

import {
  ConfigService,
  DomainService,
  ErroMessages,
  IDomain,
  IErroMessages,
  IRoute,
  KEY_CREDENTIAIS,
  RouterItemPg,
  TOKEN_KEYS,
  TokenService,
  User,
  UserSettingsService
} from 'viggo-sistemas-core-web';
import { MenuToolBarItem } from 'viggo-sistemas-core-web/modules/toolbar/components/slide-menu-right/slide-menu-right.component';

import { FastMenuService } from '@app/global services/fast-menu-service/fast-menu-service';

import { DatePipe } from '@angular/common';
import { HttpErrorResponse } from '@angular/common/http';
import { MatDialog } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import {
  NavigationEnd,
  NavigationSkipped,
  NavigationStart,
  Router,
  Scroll
} from '@angular/router';
import { DomainSettingsService } from '@app/modules/dados-empresa/services';
import { IContratoPrecificacao } from '@app/modules/precificacao/contrato_precificacao/models/contrato_precificacao.model';
import { ContratoPrecificacaoService } from '@app/modules/precificacao/contrato_precificacao/services/contrato_precificacao.service';
import { VendedorService } from '@app/modules/vendedor/services/vendedor.service';
import {
  ConfirmDialogComponent,
  ConfirmDialogData
} from '@app/shared/components';
import { DEVICE_TYPE, ScreenService } from '@app/shared/services';
import { ValidadorSettingsDomain } from '@app/shared/utils/validar_settings_domain';
import { ValidadorSettingsUser } from '@app/shared/utils/validar_settings_user';
import { filter, map, mergeMap, of } from 'rxjs';
import build from '../../../../package.json';
import { AnalyticsService, CustomMenuService } from '../../global services';

export const KEY_USA_INTEGRACAO_EXTERNAS = 'USA_INTEGRACAO_EXTERNAS';
export const KEY_NEW_VERSION = 'NEW_VERSION';
export const KEY_VERSION = 'VERSION';
export const KEY_LOGGED_SUCCESS = 'LOGGED_SUCCESS';
export const KEY_PRIMEIROS_PASSOS = 'PRIMEIROS_PASSOS';
export const KEY_REFAZER_PRIMEIROS_PASSOS = 'REFAZER_PASSOS';
export const KEY_PULOU_PRIMEIROS_PASSOS = 'PULOU_PASSOS';
export const ROUTES_FIRST_STEP = [
  '/primeiros_passos',
  '/dados-empresa/editar',
  '/dados-empresa/settings',
  '/clientes/new',
  '/vendedores/new',
  '/fornecedores/new',
  '/funcionarios/new',
  '/fabricantes/new',
  '/categoria_materia_primas/new',
  '/variacao_materia_prima/new',
  '/materia_prima/new',
  '/categoria_servicos/new',
  '/servicos/new',
  '/prioridades/new',
  '/niveis/new',
  '/tipo_erro_producao/new',
  '/linha_montagem/new',
  '/pecas/new',
  '/etapas/new',
  '/processos/new',
  '/modelos/new',
  '/gerenciar_pecas',
  '/gerenciar_materiais'
];
export interface buildMenu {
  label: string;
  items: RouterItemPg[];
  routerLink?: string[];
  icon?: string;
  precedence?: number;
}
@Component({
  selector: 'app-logged',
  templateUrl: './logged.component.html',
  styleUrls: ['./logged.component.scss'],
  providers: [
    VendedorService,
    DomainSettingsService,
    ContratoPrecificacaoService,
    DatePipe
  ]
})
export class LoggedComponent implements OnDestroy, OnInit {
  // default
  public appName: string;
  public logoToolBar = 'assets/images/vitex-icone.png';
  public firstContact = true;
  public loading = false;
  requisitions = 0;
  public empresa: IDomain;

  public menuItem = [] as buildMenu[];

  menuFast = [] as MenuToolBarItem[];

  menuProfile = [] as MenuToolBarItem[];
  // primeng

  // actions layout
  topbarMenuActive: boolean;
  menuActive: boolean;
  staticMenuDesktopInactive: boolean;
  mobileMenuActive: boolean;
  menuClick: boolean;
  mobileTopbarActive: boolean;
  topbarRightClick: boolean;
  topbarItemClick: boolean;
  activeTopbarItem: string;
  documentClickListener: () => void;
  configActive: boolean;
  configClick: boolean;
  rightMenuActive: boolean;
  menuHoverActive = false;
  searchClick = false;
  search = false;
  currentInlineMenuKey: string;
  inlineMenuActive: any[] = [];
  inlineMenuClick: boolean;

  // PrimeNG config
  topBarMode = 'visible';
  topbarTheme = 'indigo';
  menuTheme = 'light';
  layoutMode = 'light';
  menuMode = 'slim';
  inlineMenuPosition = 'bottom';
  inputStyle = 'filled';
  ripple = true;
  isRTL = false;
  isActive = false;
  itemMenu = false;
  usaCaixa = false;
  usaFiscal = false;
  actionJump = false;
  actionRebuild = false;
  isUserDefault = false;
  isUserAdmin = false;
  @ViewChild('projectLoggedFrame', { read: ElementRef })
  projectLoggedFrame: ElementRef<HTMLDivElement>;

  constructor(
    private renderer: Renderer2,
    private tokenService: TokenService,
    private matSnackBar: MatSnackBar,
    private matDialog: MatDialog,
    public router: Router,
    protected datePipe: DatePipe,
    protected menu: CustomMenuService,
    protected fastMenuService: FastMenuService,
    protected configService: ConfigService,
    protected vendedorService: VendedorService,
    protected domainService: DomainService,
    protected domainSettingsService: DomainSettingsService,
    protected userSettingsService: UserSettingsService,
    protected analyticsService: AnalyticsService,
    protected contratoService: ContratoPrecificacaoService,
    private screenService: ScreenService
  ) {
    this.buildLoggedApp();
  }

  buildLoggedApp() {
    this.appName = 'ViTex';
    localStorage.setItem(TOKEN_KEYS.URL_API, this.configService.backendURL);
    localStorage.setItem(KEY_VERSION, build.version);
    let user = this.tokenService.getUser();
    this.isUserAdmin =
      user.roles.find(rl => rl.name.toUpperCase() === 'ADMIN') !== undefined;
    this.isUserDefault =
      user.roles.find(rl => rl.name.toUpperCase() === 'SYSADMIN') !== undefined;
    this.tokenService.refreshUser(user);
    if (user) {
      user.settings = new ValidadorSettingsUser(
        user.settings,
        user.roles.find(rl => rl.name.toUpperCase() === 'SYSADMIN') !==
          undefined
      ).getUserSettingsBody(user.settings) as any;
      this.tokenService.refreshUser(user);
    }
    this.observerScreenBreakpoint();
  }

  scroll = (event): void => {
    if (
      this.isOverlay() &&
      this.projectLoggedFrame &&
      this.tokenService.isLoggedIn()
    ) {
      const elementTotal = this.projectLoggedFrame.nativeElement.getBoundingClientRect();
      if (elementTotal && elementTotal.top === 0) {
        this.topBarMode = 'visible';
      } else {
        this.topBarMode = 'hidden';
      }
    } else {
      this.topBarMode = 'visible';
    }
  };

  /**
   * Resolução m10 (1280 x 800)
   * dispositivo: Mozilla/5.0 (Linux; Android 10; K) AppleWebKit/537.36 (KHTML, like Gecko) Chrome;119.0.0.0 Safari/573.36
   * breakpoint: (min-width: 960px) and (max-width: 1279.98px)
   */
  observerScreenBreakpoint() {
    this.screenService.deviceType().subscribe(info => {
      this.menuMode =
        info.isMobile || info.deviceType === DEVICE_TYPE.DESKTOP_LOW_RESOLUTION
          ? 'overlay'
          : 'slim';
      this.initMenuItem();
    });
  }

  ngOnInit() {
    localStorage.setItem(KEY_LOGGED_SUCCESS, 'true');
    localStorage.setItem(KEY_PRIMEIROS_PASSOS, 'true');
    window.addEventListener('scroll', this.scroll, true);
    this.loading = true;
    const domain = this.tokenService.getDomain();
    domain.settings = new ValidadorSettingsDomain(
      domain.settings
    ).getDomainSettingsBody(domain.settings) as any;
    if (domain.name === 'default') {
      this.requisitions = 0;
      this.firstContact = false;
    } else if (
      domain.settings['config_inicial'].ultimo_passo === 'FINALIZADO' ||
      domain.settings['config_inicial'].ultimo_passo === 'FINALIZADO_PARCIAL'
    ) {
      this.requisitions = 0;
      this.firstContact = false;
    }
    if (
      !localStorage.getItem(KEY_PULOU_PRIMEIROS_PASSOS) &&
      !this.actionJump &&
      domain.settings['config_inicial'].pulou_passo
    )
      localStorage.setItem(
        KEY_PULOU_PRIMEIROS_PASSOS,
        domain.settings['config_inicial'].pulou_passo.toString()
      );
    if (
      !localStorage.getItem(KEY_REFAZER_PRIMEIROS_PASSOS) &&
      !this.actionRebuild &&
      !domain.settings['config_inicial'].pulou_passo
    )
      localStorage.setItem(
        KEY_REFAZER_PRIMEIROS_PASSOS,
        (!domain.settings['config_inicial'].pulou_passo).toString()
      );

    if (!this.isUserDefault) {
      this.router.events
        .pipe(
          filter(event => {
            return (
              event instanceof NavigationSkipped ||
              event instanceof NavigationStart ||
              event instanceof NavigationEnd ||
              event instanceof Scroll
            );
          })
        )
        .subscribe((event: any) => {
          let router = event as
            | NavigationEnd
            | NavigationSkipped
            | NavigationStart;
          if (event instanceof Scroll) router = event.routerEvent;
          this.requisitions += 1;
          const domain = this.tokenService.getDomain();
          if (domain) {
            domain.settings = new ValidadorSettingsDomain(
              domain.settings
            ).getDomainSettingsBody(domain.settings) as any;
            if (
              !(
                domain.settings['config_inicial'].ultimo_passo ===
                  'FINALIZADO' ||
                domain.settings['config_inicial'].ultimo_passo ===
                  'FINALIZADO_PARCIAL'
              ) &&
              (localStorage.getItem(KEY_PRIMEIROS_PASSOS) === 'true' ||
                localStorage.getItem(KEY_REFAZER_PRIMEIROS_PASSOS) ===
                  'true') &&
              localStorage.getItem(KEY_PULOU_PRIMEIROS_PASSOS) !== 'true'
            ) {
              this.requisitions = 0;
              this.firstContact = true;
              this.loading = false;
              this.empresa = domain;
              this.initMenuToolBar();
              if (
                router.url === '/workspace' ||
                router.url === '/' ||
                ROUTES_FIRST_STEP.findIndex(url => router.url.includes(url)) ===
                  -1
              )
                this.router.navigate(['/primeiros_passos']);
            } else if (
              (domain.settings['config_inicial'].ultimo_passo ===
                'FINALIZADO' ||
                domain.settings['config_inicial'].ultimo_passo ===
                  'FINALIZADO_PARCIAL' ||
                localStorage.getItem(KEY_PULOU_PRIMEIROS_PASSOS) === 'true') &&
              localStorage.getItem(KEY_PRIMEIROS_PASSOS) === 'true' &&
              this.menuItem.length === 0
            ) {
              this.requisitions = 0;
              this.firstContact = false;
              this.verificarDadosEmpresa();
            } else if (
              router.url === '/erro-integracoes-externas' &&
              this.requisitions === 1
            ) {
              this.requisitions = 0;
              this.firstContact = false;
              this.loading = false;
              this.empresa = domain;
              this.initMenuToolBar();
              this.router.navigate(['/workspace']);
            } else {
              this.loading = false;
              this.empresa = domain;
              this.initMenuToolBar();
              // this.verificarDadosEmpresa();
            }
          }
        });
      // this.verificarDadosEmpresa();
    } else {
      this.loading = false;
      this.verificarDadosEmpresa();
    }
  }

  /**
   * Baixa as informações de domain
   */
  protected verificarDadosEmpresa(): void {
    this.domainService
      .getEntity(
        this.tokenService.getDomain().id,
        'application,addresses.municipio,addresses.pais'
      )
      .pipe(
        mergeMap((entity: IDomain) => {
          entity.settings = new ValidadorSettingsDomain(
            entity.settings
          ).getDomainSettingsBody(entity.settings) as any;
          if (
            !this.isUserDefault ||
            entity.settings['config_inicial'].ultimo_passo === 'FINALIZADO' ||
            entity.settings['config_inicial'].ultimo_passo ===
              'FINALIZADO_PARCIAL' ||
            localStorage.getItem(KEY_PULOU_PRIMEIROS_PASSOS) === 'true'
          ) {
            const req = this.contratoService.getEntity(
              this.tokenService.getDomain().id,
              ['servicos.servico']
            );
            return req.pipe(
              map((contrato: IContratoPrecificacao) => {
                localStorage.setItem(
                  KEY_USA_INTEGRACAO_EXTERNAS,
                  JSON.stringify(
                    contrato.servicos.filter(it => {
                      if (
                        it.servico.tag.toString().toLowerCase() ===
                        '#clickmassa'
                      ) {
                        return it;
                      }
                    }).length === 1
                  )
                );
                return entity;
              })
            );
          } else return of(entity);
        })
      )
      .subscribe(
        dadosempresa => {
          dadosempresa.settings = new ValidadorSettingsDomain(
            dadosempresa.settings
          ).getDomainSettingsBody(dadosempresa.settings) as any;
          if (
            this.isUserDefault ||
            dadosempresa.settings['config_inicial'].ultimo_passo ===
              'FINALIZADO' ||
            dadosempresa.settings['config_inicial'].ultimo_passo ===
              'FINALIZADO_PARCIAL' ||
            localStorage.getItem(KEY_PULOU_PRIMEIROS_PASSOS) === 'true'
          ) {
            this.empresa = dadosempresa;
            this.loading = false;
            this.firstContact = false;
            if (localStorage.getItem(KEY_PULOU_PRIMEIROS_PASSOS) !== 'true') {
              localStorage.removeItem(KEY_PRIMEIROS_PASSOS);
              localStorage.removeItem('UFICMS_ID');
              localStorage.removeItem('dialogOpened');
              localStorage.removeItem('dialogConcluidedOpened');
            }
            // this.menuActive = !(this.isOverlay() && !this.isMobile());
            if (!this.itemMenu) this.initMenuItem();
            // this.initMenuItem();
            this.initMenuToolBar();
            this.checkTypeUser();
          } else if (
            this.isUserAdmin &&
            (dadosempresa.settings['config_inicial'].ultimo_passo !==
              'FINALIZADO' ||
              dadosempresa.settings['config_inicial'].ultimo_passo !==
                'FINALIZADO_PARCIAL' ||
              localStorage.getItem(KEY_REFAZER_PRIMEIROS_PASSOS) === 'true') &&
            localStorage.getItem(KEY_PULOU_PRIMEIROS_PASSOS) !== 'true'
          ) {
            localStorage.setItem(KEY_PRIMEIROS_PASSOS, 'true');
            this.empresa = dadosempresa;
            this.loading = false;
            this.firstContact = true;
            this.initMenuToolBar();
            this.router.navigate(['/primeiros_passos']);
          } else {
            this.empresa = dadosempresa;
            this.loading = false;
            this.firstContact = true;
            this.initMenuToolBar();
            this.router.navigate(['/primeiros_passos']);
          }
        },
        (err: HttpErrorResponse) => {
          this.displayError(err, true);
        }
      );
  }

  checkTypeUser() {
    const user = this.tokenService.getUser() as User;
    const roleVendedor = user.roles.find(rl => rl.name === 'Vendedor');
    const existVendedorLogado = localStorage.getItem('VENDEDOR_LOGADO');
    if (roleVendedor && !existVendedorLogado) {
      this.vendedorService
        .getEntitiesByParams(
          `include=parceiro.enderecos&parceiro.user_id=${user.id}&page=0&page_size=1`,
          this.tokenService.getDomain().id,
          true
        )
        .subscribe(
          vend => {
            if (vend.data.length === 1) {
              localStorage.setItem(
                'VENDEDOR_LOGADO',
                JSON.stringify(vend.data[0])
              );
            }
          },
          (err: HttpErrorResponse) => {
            this.displayError(err, true);
          }
        );
    }
  }

  protected initMenuToolBar() {
    this.menuProfile = [
      {
        title: 'Informações de usuário',
        icon: 'pi pi-user',
        action: true
      },
      {
        title: 'Alterar senha',
        icon: 'pi pi-lock',
        action: true
      },
      {
        title: 'Sair',
        icon: 'pi pi-power-off',
        action: true
      }
    ] as MenuToolBarItem[];
    if (
      this.tokenService.isLoggedIn() &&
      this.tokenService.getRoutes().length !== 0 &&
      this.menuFast.length === 0 &&
      !this.firstContact
    ) {
      this.fastMenuService.onCreateFastMenu().subscribe(fastMenuIt => {
        this.menuFast = fastMenuIt;
      });
    }
  }

  /**
   * Valida as rotas do usuário
   * @param routes
   * @param url_name
   * @returns
   */
  verificarRotasDeAcesso(routes: IRoute[], url_name: string): IRoute[] {
    if (routes && routes.length > 0 && url_name) {
      return routes.filter(r => new RegExp(`^${url_name}`).test(r.url));
    }
  }

  /**
   * Valida se as rotas do usuário são equivalentes ao pacote de rotas do fiscal
   * @param routesAuthorization
   * @param action
   * @param params
   * @param url_name
   * @returns
   */
  validarAdicao(
    routesAuthorization: IRoute[],
    action: string,
    params = '',
    url_name: string
  ): boolean {
    if (routesAuthorization && routesAuthorization.length > 0) {
      const url_return = routesAuthorization.find(
        route => route.url === url_name && route.method === action
      );
      return !!url_return;
    }
  }

  /**
   * Verifica se preenche ou nao o menu de user
   * @returns
   */
  verificarMenuUser() {
    const action = 'POST' as string;
    const params = '' as string;
    const url_users = '/users' as string;

    const routesAuthorization = this.verificarRotasDeAcesso(
      this.tokenService.getRoutes(),
      url_users
    ) as IRoute[];

    const permitirMenuUser = this.validarAdicao(
      routesAuthorization,
      action,
      params,
      url_users
    );
    return permitirMenuUser;
  }

  /**
   * Verifica se o dominio usa do módulo caixa ou não
   * @returns
   */
  verificarUsaCaixa() {
    const action = 'POST' as string;
    const params = '' as string;
    const url_caixa_pedido_nfce = '/cupons' as string;

    const routesAuthorizationCaixa = this.verificarRotasDeAcesso(
      this.tokenService.getRoutes(),
      url_caixa_pedido_nfce
    ) as IRoute[];

    const usaCaixa = this.validarAdicao(
      routesAuthorizationCaixa,
      action,
      params,
      url_caixa_pedido_nfce
    );
    localStorage.setItem('usaCaixa', usaCaixa ? usaCaixa.toString() : 'false');
    return usaCaixa;
  }

  /**
   * Preenhce o usaFiscal no localStorage caso o usuário tenha o pacote NFe
   * @returns
   */
  verificarUsaFiscal() {
    const action = 'POST' as string;
    const params = '' as string;
    const url_nfe = '/nfes' as string;
    const url_nfce = '/nfces' as string;
    // var routesAuthorization: IRoute[] = [];
    const routesAuthorizationNFe = this.verificarRotasDeAcesso(
      this.tokenService.getRoutes(),
      url_nfe
    ) as IRoute[];

    const routesAuthorizationNFCe = this.verificarRotasDeAcesso(
      this.tokenService.getRoutes(),
      url_nfce
    ) as IRoute[];

    const fiscalNFe = this.validarAdicao(
      routesAuthorizationNFe,
      action,
      params,
      url_nfe
    );

    const fiscalNFCe = this.validarAdicao(
      routesAuthorizationNFCe,
      action,
      params,
      url_nfce
    );
    const fiscal = fiscalNFe || fiscalNFCe;
    localStorage.setItem('usaFiscal', fiscal ? fiscal.toString() : 'false');
    localStorage.setItem(
      'usaFiscalNFe',
      fiscalNFe ? fiscalNFe.toString() : 'false'
    );
    localStorage.setItem(
      'usaFiscalNFCe',
      fiscalNFCe ? fiscalNFCe.toString() : 'false'
    );
    return fiscal;
  }

  /**
   * Verifica se o usuário tem acesso ao menu de integração
   */
  verificarMenuIntegracao() {
    const action = 'GET' as string;
    const params = '' as string;
    const url_integracao = '/click_massa_clientes/<id>' as string;

    const routesAuthorization = this.verificarRotasDeAcesso(
      this.tokenService.getRoutes(),
      url_integracao
    ) as IRoute[];

    const permitIntegracao = this.validarAdicao(
      routesAuthorization,
      action,
      params,
      url_integracao
    );
    return (
      permitIntegracao &&
      localStorage.getItem(KEY_USA_INTEGRACAO_EXTERNAS) === 'true'
    );
  }

  protected initMenuItem() {
    this.itemMenu = true;
    this.loading = true;
    // mount menu routes
    this.menu.onCreateMenuPrimeNg().subscribe(
      menuItem => {
        this.menuItem = [];
        this.usaCaixa = this.verificarUsaCaixa();
        this.usaFiscal = this.verificarUsaFiscal();
        if (this.isSlim()) {
          const prevMenu = this.menuItem;
          // const index = this.menuItem.findIndex(m => m.label.includes('Menu'));
          // if (index >= 0) {
          //   prevMenu.splice(index, 1);
          //   this.menuItem = prevMenu;
          // }
          var menuUser = {} as buildMenu;
          var menuIntegracao = {} as RouterItemPg;
          menuItem.map((item, index) => {
            if (item) {
              if (item.label === 'Segurança') {
                if (this.verificarMenuUser())
                  menuUser = {
                    label: item.label,
                    icon: item.icon,
                    routerLink: item.routerLink,
                    items: item.items
                  };
              } else if (item.label === 'Configurações') {
                item.items = item.items.filter(it => {
                  if (it.label === 'Integrações') {
                    if (this.verificarMenuIntegracao()) menuIntegracao = it;
                  } else {
                    return it;
                  }
                });
                this.menuItem.push({
                  label: item.label,
                  icon: item.icon,
                  routerLink: item.routerLink,
                  items: item.items,
                  precedence: index > 0 ? index - 1 : index
                });
              } else
                this.menuItem.push({
                  label: item.label,
                  icon: item.icon,
                  routerLink: item.routerLink,
                  items: item.items,
                  precedence: index > 0 ? index - 1 : index
                });
            }
            if (
              Object.keys(menuUser).length !== 0 &&
              index + 1 === menuItem.length
            ) {
              this.menuItem.push({ ...menuUser, precedence: index });
            }
            if (
              Object.keys(menuIntegracao).length !== 0 &&
              index + 1 === menuItem.length
            ) {
              this.menuItem.forEach(it => {
                if (it.label === 'Configurações') {
                  it.items.push(menuIntegracao);
                }
              });
            }
          });
        } else {
          this.menuItem.push({
            label: 'Menu',
            icon: 'pi pi-fw pi-play',
            items: []
          });
          this.menuItem[0].items = menuItem.map(item => item);
        }
      },
      () => {},
      () => {
        this.loading = false;
        if (!this.tokenService.isMenuItemLs())
          this.router.navigate(['/workspace']);
      }
    );
  }

  ngAfterViewInit() {
    // hides the horizontal submenus or top menu if outside is clicked
    this.documentClickListener = this.renderer.listen('body', 'click', () => {
      if (!this.topbarItemClick) {
        this.activeTopbarItem = null;
        this.topbarMenuActive = false;
      }

      if (!this.menuClick && (this.isHorizontal() || this.isSlim())) {
        this.menu.reset();
      }

      if (this.configActive && !this.configClick) {
        this.configActive = false;
      }

      if (!this.menuClick) {
        if (this.mobileMenuActive) {
          this.mobileMenuActive = false;
        }

        if (this.isOverlay()) {
          this.menuActive = false;
        }

        this.menuHoverActive = false;
        this.unblockBodyScroll();
      }

      if (!this.searchClick) {
        this.search = false;
      }

      if (
        this.inlineMenuActive[this.currentInlineMenuKey] &&
        !this.inlineMenuClick
      ) {
        this.inlineMenuActive[this.currentInlineMenuKey] = false;
      }

      this.inlineMenuClick = false;
      this.searchClick = false;
      this.configClick = false;
      this.topbarItemClick = false;
      this.topbarRightClick = false;
      this.menuClick = false;
    });
  }

  onMenuButtonClick(event) {
    this.menuActive = !this.menuActive;
    this.topbarMenuActive = false;
    this.topbarRightClick = true;
    this.menuClick = true;

    if (this.isDesktop()) {
      this.staticMenuDesktopInactive = !this.staticMenuDesktopInactive;
    } else {
      this.mobileMenuActive = !this.mobileMenuActive;
      if (this.mobileMenuActive) {
        this.blockBodyScroll();
      } else {
        this.unblockBodyScroll();
      }
    }

    event.preventDefault();
  }

  onTopbarMobileButtonClick(event) {
    this.mobileTopbarActive = !this.mobileTopbarActive;
    event.preventDefault();
  }

  onMenuClick(event) {
    this.menuClick = true;

    if (
      this.inlineMenuActive[this.currentInlineMenuKey] &&
      !this.inlineMenuClick
    ) {
      this.inlineMenuActive[this.currentInlineMenuKey] = false;
    }
  }

  blockBodyScroll(): void {
    if (document.body.classList) {
      document.body.classList.add('blocked-scroll');
    } else {
      document.body.className += ' blocked-scroll';
    }
  }

  unblockBodyScroll(): void {
    if (document.body.classList) {
      document.body.classList.remove('blocked-scroll');
    } else {
      document.body.className = document.body.className.replace(
        new RegExp(
          `(^|\\b)${'blocked-scroll'.split(' ').join('|')}(\\b|$)`,
          'gi'
        ),
        ' '
      );
    }
  }

  isTopBarVisible() {
    return this.topBarMode === 'visible';
  }

  isTopBarHidden() {
    return this.topBarMode === 'hidden' && !this.menuActive;
  }

  isDesktop() {
    return window.innerWidth > 1920;
  }

  isMobile() {
    return window.innerWidth <= 1920;
  }

  isStatic() {
    return this.menuMode === 'static';
  }

  isHorizontal() {
    return this.menuMode === 'horizontal';
  }

  isSlim() {
    return this.menuMode === 'slim';
  }

  isOverlay() {
    return this.menuMode === 'overlay';
  }

  ngOnDestroy() {
    window.removeEventListener('scroll', this.scroll, true);
    if (this.documentClickListener) {
      this.documentClickListener();
    }
  }

  get isLoggedIn() {
    return this.tokenService.isLoggedIn();
  }

  displayError(err: HttpErrorResponse, showDefaultMsg = false) {
    const txtMsg = showDefaultMsg
      ? `Identificamos o erro ${err.status} - ${err.statusText} no processamento dos dados!`
      : err.error;
    const errorMsg = new ErroMessages({
      route: this.router.url,
      router: this.router,
      matSnackBar: this.matSnackBar,
      matDialog: this.matDialog,
      httpError: err,
      showDefaultMsg: showDefaultMsg,
      loginService: null,
      tokenService: this.tokenService,
      vlMsgDefault: txtMsg,
      dialogComponent: ConfirmDialogComponent,
      dialogData: {
        config: {
          data: {
            title: 'Aviso',
            icon: 'warning',
            bodyMessage: txtMsg,
            icon_color: 'accent',
            singleBtn: true
          } as ConfirmDialogData,
          width: '500px'
        }
      }
    } as IErroMessages);
    errorMsg.showMessageObject(txtMsg);
    // errorMsg.checkError();
  }

  /**
   * Verifica as settings de passos do domínio e estabiliza a exibição do FAB
   * na validação não era necessário checar a setting de 'pulou_passo' já que só
   * checar o último passo já serviria como embasamento da validação, porém
   * adicionei para ficar lembrando que existe essa info na settings caso precise
   * @returns
   */
  showFab() {
    if (this.empresa && !this.isUserDefault) {
      const { pulou_passo, ultimo_passo } = this.empresa.settings[
        'config_inicial'
      ];
      if (pulou_passo) {
        return !(
          ultimo_passo === 'FINALIZADO' || ultimo_passo === 'FINALIZADO_PARCIAL'
        );
      }
      return (
        !pulou_passo &&
        !(
          ultimo_passo === 'FINALIZADO' || ultimo_passo === 'FINALIZADO_PARCIAL'
        )
      );
    }
    return false;
  }

  showFabVersion() {
    return localStorage.getItem(KEY_NEW_VERSION) === 'true';
  }

  actionFab() {
    const refazer =
      localStorage.getItem(KEY_REFAZER_PRIMEIROS_PASSOS) === 'true';
    const pular = localStorage.getItem(KEY_PULOU_PRIMEIROS_PASSOS) === 'true';
    return !pular ? this.pularPrimeirosPassos() : this.refazerPrimeirosPassos();
  }

  iconFab() {
    const refazer =
      localStorage.getItem(KEY_REFAZER_PRIMEIROS_PASSOS) === 'true';
    const pular = localStorage.getItem(KEY_PULOU_PRIMEIROS_PASSOS) === 'true';
    return !pular ? 'mdi mdi-run fs-large' : 'pi pi-fw pi-refresh fs-large';
  }

  getTooltipFab() {
    const refazer =
      localStorage.getItem(KEY_REFAZER_PRIMEIROS_PASSOS) === 'true';
    const pular = localStorage.getItem(KEY_PULOU_PRIMEIROS_PASSOS) === 'true';
    return !pular ? 'Pular primeiros passos' : 'Refazer primeiros passos';
  }

  /**
   * Realiza a mudança de valor nas settings do domínio para 'pulou_passo' ser TRUE
   * e rebuilda a tela. O valor de this.empresa é povoado la no ngOnInit e também na
   * função de verificarDadosEmpresa
   */
  pularPrimeirosPassos() {
    if (this.empresa) {
      this.actionJump = true; // flag associada ao preenchimento de LS KEY_PULAR_PASSOS por meio das settings
      const settings = {
        ...this.empresa.settings,
        config_inicial: {
          ...this.empresa.settings['config_inicial'],
          pulou_passo: true
        }
      };
      this.domainSettingsService.update(settings).subscribe(
        (result: any) => {
          if (result) {
            this.empresa.settings = {
              ...settings
            };
            this.tokenService.saveDomain(this.empresa);
            localStorage.setItem(KEY_PULOU_PRIMEIROS_PASSOS, 'true');
            localStorage.removeItem(KEY_REFAZER_PRIMEIROS_PASSOS);
            this.router.navigate(['/']);
          }
        },
        (error: HttpErrorResponse) => {
          this.displayError(error);
        }
      );
    }
  }

  /**
   * Realiza a mudança de valor nas settings do domínio para 'pulou_passo' ser FALSE
   * e rebuilda a tela. O valor de this.empresa é povoado la no ngOnInit e também na
   * função de verificarDadosEmpresa. Ao final eu aciono a função de verificarDadosEmpresa,
   * pois é necessário remover o menu lateral já que na tela de primeiros passos não faz sentido ter
   */
  refazerPrimeirosPassos() {
    if (this.empresa) {
      this.actionRebuild = true; // flag associada ao preenchimento de LS KEY_REFAZER_PASSOS por meio das settings
      this.loading = true;
      const settings = {
        ...this.empresa.settings,
        config_inicial: {
          ...this.empresa.settings['config_inicial'],
          pulou_passo: false
        }
      };
      this.domainSettingsService.update(settings).subscribe(
        (result: any) => {
          if (result) {
            this.empresa.settings = {
              ...settings
            };
            this.tokenService.saveDomain(this.empresa);
            localStorage.setItem(KEY_REFAZER_PRIMEIROS_PASSOS, 'true');
            localStorage.removeItem(KEY_PULOU_PRIMEIROS_PASSOS);
            this.menuItem = [];
            this.itemMenu = false;
            this.verificarDadosEmpresa();
            // this.router.navigate(['/primeiros_passos']);
          }
        },
        (error: HttpErrorResponse) => {
          this.displayError(error);
        }
      );
    }
  }

  public updateVersion() {
    this.matDialog
      .open(ConfirmDialogComponent, {
        data: {
          bodyMessage:
            'Parece que você está utilizando uma versão desatualizada! \n Deseja realizar atualização do sistema agora ou mais tarde?',
          title: 'Atualização do sistema',
          icon: 'sync',
          icon_color: 'primary',
          labelCloseButton: 'Deixar para depois',
          labelConfirmButton: 'Atualizar agora',
          breakline: true
        } as ConfirmDialogData,
        disableClose: true,
        panelClass: ['custom-container'],
        width: '500px'
      })
      .afterClosed()
      .subscribe(confirm => {
        if (confirm) {
          this.onLogOut();
        }
      });
  }

  public onLogOut() {
    if (this.tokenService.isLoggedIn()) {
      var user = this.tokenService.getUser() as User;
      user = {
        ...user,
        settings: {
          ...user.settings,
          primeiro_acesso: false,
          version: {
            ...user.settings['version'],
            web_version: localStorage.getItem(KEY_VERSION)
          }
        } as any
      };
      this.userSettingsService.update(user.settings, user.id).subscribe(
        vl => {
          this.tokenService.onLogout().subscribe(
            () => {
              const credentials = localStorage.getItem(KEY_CREDENTIAIS);
              const URL_API = localStorage.getItem(TOKEN_KEYS.URL_API);
              localStorage.clear();
              localStorage.setItem(KEY_CREDENTIAIS, credentials);
              localStorage.setItem(TOKEN_KEYS.URL_API, URL_API);
              this.router.navigate(['/auth/login']);
            },
            (err: HttpErrorResponse) => {
              if (err && err.error) this.displayError(err);
            },
            () => {
              this.router.navigate(['/auth/login']).finally(() => {
                if (!this.tokenService.isLoggedIn()) window.location.reload();
              });
            }
          );
        },
        (err: HttpErrorResponse) => {
          this.displayError(err);
        }
      );
    }
  }
}
